// frontend/src/components/dashboard/ProgressDonutCard.tsx

import { Link } from 'react-router-dom';

interface ProgressDonutCardProps {
  completedLessons: number;
  totalXp: number;
  badges: number;
  overallPercent: number;
}

export function ProgressDonutCard({ completedLessons, totalXp, badges, overallPercent }: ProgressDonutCardProps) {
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const dashoffset = circumference - (overallPercent / 100) * circumference;

  return (
    <div className="nd-card nd-donut-card">
      <div className="nd-card-header" style={{ width: '100%', justifyContent: 'center' }}>
        <h2 className="nd-card-title">
          <span className="nd-card-title-icon">📊</span>
          İlerleme Durumun
        </h2>
      </div>
      <div className="nd-donut-wrap">
        <svg width="180" height="180" className="nd-donut-svg">
          {/* Background track */}
          <circle
            cx="90" cy="90" r={radius}
            fill="none"
            stroke="rgba(23, 199, 154, 0.12)"
            strokeWidth="14"
          />
          {/* Progress arc */}
          <circle
            cx="90" cy="90" r={radius}
            fill="none"
            stroke="url(#donutGradLanding)"
            strokeWidth="14"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={dashoffset}
            transform="rotate(-90 90 90)"
            style={{ transition: 'stroke-dashoffset 0.8s cubic-bezier(0.16,1,0.3,1)' }}
          />
          <defs>
            <linearGradient id="donutGradLanding" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#06B6D4" />
              <stop offset="100%" stopColor="#17C79A" />
            </linearGradient>
          </defs>
          <text x="90" y="86" textAnchor="middle" className="nd-donut-percent" fill="#0A1A14" fontSize="28" fontWeight="900" fontFamily="Space Grotesk, sans-serif">
            %{overallPercent}
          </text>
          <text x="90" y="106" textAnchor="middle" fill="rgba(13, 46, 38, 0.65)" fontSize="12" fontWeight="700" fontFamily="Plus Jakarta Sans, sans-serif">
            Genel İlerleme
          </text>
        </svg>
      </div>
      <div className="nd-donut-stats">
        <div className="nd-donut-stat">
          <div className="nd-donut-stat-label">Tamamlanan</div>
          <div className="nd-donut-stat-value">{completedLessons}</div>
        </div>
        <div className="nd-donut-stat">
          <div className="nd-donut-stat-label">Kazanılan Puan</div>
          <div className="nd-donut-stat-value">{totalXp.toLocaleString('tr-TR')}</div>
        </div>
        <div className="nd-donut-stat">
          <div className="nd-donut-stat-label">Rozetler</div>
          <div className="nd-donut-stat-value">{badges}</div>
        </div>
      </div>
      <Link to="/dashboard/report" className="nd-detail-btn">Detaylı Raporu Gör →</Link>
    </div>
  );
}

